import { render, staticRenderFns } from "./InvoiceInsert.vue?vue&type=template&id=516f2a60&scoped=true&"
import script from "./InvoiceInsert.vue?vue&type=script&lang=js&"
export * from "./InvoiceInsert.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceInsert.vue?vue&type=style&index=0&id=516f2a60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516f2a60",
  null
  
)

export default component.exports